import { GerenciaComponent } from './pages/gerencia/gerencia.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './_guards/authGuard';
import { HomeComponent } from './pages/home/home.component';
import { LayoutComponent } from './pages/layout/layout.component';
import { Routes, RouterModule } from '@angular/router';

import { CupomComponent } from './pages/cupom/cupom.component';
import { PerfilComponent } from './pages/perfil/perfil.component';
import { AlterarSenhaComponent } from './pages/alterar-senha/alterar-senha.component';
import { UploadCargaComponent } from './pages/upload-carga/upload-carga.component';
import { RelatorioComponent } from './pages/relatorio/relatorio.component';
import { RedeCredenciadaComponent } from './pages/rede-credenciada/rede-credenciada.component';

const appRoutes: Routes = [
  { path: '', 
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'home', component: HomeComponent, pathMatch: 'full' },
      { path: 'cupom', component: CupomComponent },
      { path: 'perfil/:id', component: PerfilComponent },
      { path: 'perfil', component: PerfilComponent },
      { path: 'gerencia', component: GerenciaComponent },
      { path: 'uploadCarga', component: UploadCargaComponent },
      { path: 'relatorio', component: RelatorioComponent },
      { path: 'rede-credenciada', component: RedeCredenciadaComponent }
    ]
   },
  { path: 'login', component: LoginComponent },
  { path: 'alterarSenha/:id', component: AlterarSenhaComponent },
  { path: 'rede-credenciada-no-login', component: RedeCredenciadaComponent }
  //{ path: '**', redirectTo: '/home' } 
];

export const routing = RouterModule.forRoot(appRoutes, { useHash: true });
